<template>
  <div class="sidebar__filters">
    <FilterList
            v-if="filters && filters.length"
            v-for="item in filters"
            :key="item.title"
            :title="item.title"
            :slug="item.slug"
            :items="item.categories"
            @heightChanged="$emit('heightChanged')"
    />
  </div>
</template>
<script>
import FilterList from './FilterList'
import {useStore} from 'vuex'
import {computed} from "vue";

export default {
  name: 'Filters',
  components: {FilterList},
  setup() {
    const store = useStore()
    const filters = computed(() => store.getters.filters)
    return {
      filters,
    }
  }
}
</script>